import React from 'react';
import { Modal, Button, Typography, Space } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { useIntl } from 'react-intl';

const { Paragraph } = Typography;

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15);
  }

  .ant-modal-header {
    background: linear-gradient(135deg, #faad14 0%, #ffc53d 100%);
    border-bottom: none;
    padding: 24px 24px 20px;
    border-radius: 16px 16px 0 0;
  }

  .ant-modal-title {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
  }

  .ant-modal-close {
    display: none;
  }

  .ant-modal-body {
    padding: 32px 24px;
  }

  .ant-modal-footer {
    border-top: none;
    padding: 16px 24px 24px;
  }
`;

const CutoffIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;

  .anticon {
    font-size: 64px;
    color: #faad14;
  }
`;

const CutoffContent = styled.div`
  text-align: center;
`;

const CutoffMessage = styled(Paragraph)`
  font-size: 15px;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 0 !important;
  line-height: 1.6;
  white-space: pre-line;
`;

const StyledButton = styled(Button)`
  height: 44px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 15px;
`;

interface BookingCutoffModalProps {
  isOpen: boolean;
  cutoffTime?: string | null;
  onClose: () => void;
  onSearchTomorrow: () => void;
}

const BookingCutoffModal: React.FC<BookingCutoffModalProps> = ({
  isOpen,
  cutoffTime,
  onClose,
  onSearchTomorrow,
}) => {
  const intl = useIntl();

  return (
    <StyledModal
      title={intl.formatMessage({ id: 'booking.cutoffModal.title' })}
      open={isOpen}
      onCancel={onClose}
      centered
      width={440}
      closable={false}
      mask={{
        closable: false,
      }}
      keyboard={false}
      footer={[
        <Button key="cancel" onClick={onClose} style={{ height: 44, borderRadius: 8 }}>
          {intl.formatMessage({ id: 'booking.cutoffModal.cancel' })}
        </Button>,
        <StyledButton key="searchTomorrow" type="primary" onClick={onSearchTomorrow}>
          {intl.formatMessage({ id: 'booking.cutoffModal.searchTomorrow' })}
        </StyledButton>,
      ]}
    >
      <Space orientation="vertical" size="large" style={{ width: '100%' }}>
        <CutoffIconWrapper>
          <ClockCircleOutlined />
        </CutoffIconWrapper>
        <CutoffContent>
          <CutoffMessage>
            {intl.formatMessage(
              { id: 'booking.cutoffModal.description' },
              { time: cutoffTime ?? '' },
            )}
          </CutoffMessage>
        </CutoffContent>
      </Space>
    </StyledModal>
  );
};

export default BookingCutoffModal;
